import { TableCell, styled } from '@mui/material';

export const TableCellWithWidth = styled(TableCell)(({ w }) => ({
  width: `${w}%`
}));
